/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Oi as Oi,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_h as h,
} from "../../runtime/index.jsx";
export function PantallaActualizando(e) {
  let t = (0, ReactCompiler.c)(6),
    { texto: n } = e,
    r = n === void 0 ? `Actualizando el planner…` : n,
    i;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((i = <Oi className={`h-8 w-8 animate-spin text-(--accent)`} />),
      (t[0] = i))
    : (i = t[0]);
  let a;
  t[1] === r
    ? (a = t[2])
    : ((a = (
        <p className={`text-base font-medium text-(--text-h)`} children={r} />
      )),
      (t[1] = r),
      (t[2] = a));
  let o;
  t[3] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((o = (
        <p
          className={`max-w-xs text-sm text-(--text)`}
          children={`Son unos segundos. No cierres la aplicación: lo que tengas guardado se envía igual.`}
        />
      )),
      (t[3] = o))
    : (o = t[3]);
  let s;
  return (
    t[4] === a
      ? (s = t[5])
      : ((s = (0, h.createPortal)(
          <div
            className={`animar-fundido fixed inset-0 z-[70] flex flex-col items-center justify-center gap-4 bg-(--bg) p-6 text-center`}
            role={`status`}
            aria-live={`polite`}
            children={[i, a, o]}
          />,
          document.body,
        )),
        (t[4] = a),
        (t[5] = s)),
    s
  );
}
